import React, { FC } from 'react';
import { Typography } from '../../../../../components/Typography';
import { FlexGrid, FlexGridColumn } from '../../../../../components/FlexGrid';
import { ModSurveys } from '../../../../../components/Icons/ModSurveys';
import { gray } from '../../../../../components/Color';

export const IssueDetailContactUsMessage: FC<React.PropsWithChildren<{ message: string }>> = ({ message }) => {
	return (
		<FlexGrid
			gap='tiny'
			center
		>
			<FlexGridColumn
				noGrow
				noShrink
			>
				<ModSurveys
					height='24px'
					width='24px'
					fill={gray[6]}
				/>
			</FlexGridColumn>
			<FlexGridColumn grow>
				<Typography
					fontSize='20px'
					color={gray[6]}
				>
					{message}
				</Typography>
			</FlexGridColumn>
		</FlexGrid>
	);
};
